import loadMoreButton from '~/js/lib/collection'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */
  const overlay = document.querySelector('[data-customer-menu-overlay]');
  const closeButton = node.querySelector('[data-button-close]');
  const logoutButton = node.querySelector('[data-logout-button]');
  const customerOverlay = document.querySelector('[data-customer-overlay]');
  let closeListener = null;

  /**
   * Functions
   */
  const openCustomerMenu = () => {
    node.classList.add('!translate-y-0');
    node.classList.remove('opacity-0');
    node.classList.add('md:!translate-x-0');
    overlay.classList.remove('hidden');
    closeListener = closeButton.addEventListener('click', closeCustomerMenu);
  };

  const closeCustomerMenu = () => {
    node.classList.add('opacity-0');
    node.classList.remove('!translate-y-0');
    node.classList.remove('md:!translate-x-0');
    overlay.classList.add('hidden');
    closeListener = closeButton.removeEventListener('click', closeCustomerMenu);
  };

  const initEventListeners = () => {
    const closeButton = node.querySelector('[data-button-close]');
    closeButton.addEventListener('click', closeCustomerMenu);
    logoutButton.addEventListener('click', logoutUser);
  };

  const logoutUser = async () => {
    // first clear the cart
    customerOverlay.classList.remove('hidden');
    await fetch('/cart/clear', {
      method: 'GET',
    });
    const logoutUrl = logoutButton.dataset.logoutUrl;
    window.location.href = logoutUrl;
  };

  /**
   * Init
   */
  const init = () => {
    document.addEventListener('customer-menu:open', openCustomerMenu);
    overlay.addEventListener('click', closeCustomerMenu);
    initEventListeners();
  };

  init();
};
